//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import gaApi from 'app/initialization/ga/ga-api';

const windowRef = window as any;

windowRef.fbAsyncInit = () => {
  FB.init({
    appId: '692537704104965', // TODO Pass from env variables in new framework
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v3.2',
  });

  // This call is issued in order to refresh the logged in user's token.  Specifically it will
  // refresh the Data Access expiry of the token.
  FB.getLoginStatus((response) => {
    gaApi.recordEvent(
      gaApi.CATEGORY_PAGE_LOAD,
      gaApi.ACTION_LOAD_FACEBOOK_SDK,
      response.status,
    );
  });
};

(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');
